import { render } from "./flashcards-list.vue?vue&type=template&id=c07a4900&scoped=true"
import script from "./flashcards-list.vue?vue&type=script&lang=js"
export * from "./flashcards-list.vue?vue&type=script&lang=js"

import "./flashcards-list.vue?vue&type=style&index=0&id=c07a4900&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07a4900"]])

export default __exports__